import { useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { downloadCSV } from './csvUtils';
import { trackMixpanelEvent } from '../utils/general';
import { INSIGHTS_TAB, TRACK_EVENT_PREFIX } from './consts';
import { GET_CREATIVE_TAGS } from './queries';

const useCsvDownload = ({
    creatives,
    selectedAppOption,
    selectedSourceOption,
    dateRange,
    selectedCohorts,
    selectedTab,
    insightsDownloadUrl,
}) => {
    const [creativesTags, setCreativesTags] = useState();

    const [getCreativesTags, { data: creativesTagsResponse, loading: isLoadingCreativesTags }] = useLazyQuery(
        GET_CREATIVE_TAGS
    );

    const shouldCancelTagsFetch = useRef(false);

    useEffect(() => {
        // When we switch the filters when a csv export is loading, the response still comes back even though its
        // irrelevant, in these cases we use a var saying we need to skip the response received
        if (shouldCancelTagsFetch.current) {
            shouldCancelTagsFetch.current = false;
            return;
        }

        if (creativesTagsResponse) {
            setCreativesTags(creativesTagsResponse.creativeTags.tags);
        }
    }, [creativesTagsResponse]);

    useEffect(() => {
        if (isLoadingCreativesTags || !creativesTags || !selectedAppOption || !selectedSourceOption) return;

        downloadCSV(
            creatives,
            creativesTags,
            selectedAppOption.label,
            selectedSourceOption.label,
            dateRange,
            selectedCohorts
        );
    }, [creativesTags, isLoadingCreativesTags]);

    const onCsvDownloadClicked = () => {
        if (selectedTab === INSIGHTS_TAB && insightsDownloadUrl) {
            window.open(insightsDownloadUrl, '_blank', 'noopener,noreferrer');
            return;
        }

        trackMixpanelEvent(TRACK_EVENT_PREFIX, 'CSV Export Clicked', {
            app: selectedAppOption?.name,
            source: selectedSourceOption?.name,
        });

        if (creativesTags) {
            downloadCSV(
                creatives,
                creativesTags,
                selectedAppOption.label,
                selectedSourceOption.label,
                dateRange,
                selectedCohorts
            );
        } else {
            getCreativesTags({
                variables: {
                    imageHashes: creatives.map(creative => creative.imageHash),
                    appId: selectedAppOption.value,
                },
            });
        }
    };

    useEffect(() => {
        setCreativesTags(null);
    }, [creatives]);

    return {
        onCsvDownloadClicked,
        isLoadingCreativesTags,
        creativesTags,
        shouldCancelTagsFetch,
    };
};

export default useCsvDownload;
